import { AutogenModelTractorEquipType, AutogenRowTractorEquipType } from "./autogen/AutogenModelTractorEquipType";

export class ModelTractorEquipType extends AutogenModelTractorEquipType<RowTractorEquipType> {
	constructor() {
		super(RowTractorEquipType);
	}
}

export class RowTractorEquipType extends AutogenRowTractorEquipType {
}